<template>
  <b-container fluid>
    <div class="row">
      <div class="col-lg-2 pb-4">
        <router-link
          :to="{ name: 'templates.create' }"
          v-if="$allowedRoute('templates.create')"
        >
          <b-button block variant="primary" outline size="lg">
            <i class="fas fa-plus"></i>
            Add
          </b-button>
        </router-link>
      </div>
    </div>
    <div class="row">
      <b-col>
        <iq-card>
          <template v-slot:body class="pt-0">
            <b-row>
              <b-col>
                <b-row>
                  <b-col>
                    <h4 class="card-title">Search by</h4>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group class="mb-0">
                      <b-form-input
                        id="search"
                        type="text"
                        placeholder="enter template name"
                        size="sm"
                        v-model="search"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-row>
                  <b-col>
                    <h5>Filter by product groups</h5>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <v-select
                      multiple
                      :closeOnSelect="false"
                      v-model="selectedProductGroupIds"
                      :reduce="(productGroup) => productGroup.id"
                      label="name"
                      :options="productGroupOptions"
                    ></v-select>
                  </b-col>
                </b-row>
              </b-col>
               <b-col>
                <b-row>
                  <b-col>
                    <h5>Filter by min. audience</h5>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-select
                          plain
                          v-model="selectedMinAudience"
                          :options="minAudienceOptions"
                          size="sm"
                          class="mb-3"
                        >
                          <template v-slot:first>
                            <b-form-select-option :value="null"
                              >select audience</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-if="role === 'sales_manager'">
              <b-col>
                <b-row>
                  <b-col>
                    <h5>Filter by user</h5>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <v-select
                      multiple
                      :closeOnSelect="false"
                      v-model="selectedUserIds"
                      :reduce="(user) => user.id"
                      label="email"
                      :options="users"
                    ></v-select>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </div>
    <div class="row">
      <b-col>
        <iq-card>
          <template v-slot:body>
            <b-table
              hover
              responsive
              :items="items"
              :fields="fields"
              class="mb-0 table-borderless"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :busy="loading"
              data-cy="template-table"
              sort-icon-left
            >
              <template #table-busy>
                <div class="text-center p-4" style="color: var(--iq-primary)">
                  <b-spinner class="align-middle mr-3"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(owner)="data">
                <Avatar
                  :imageUrl="data.item.owner.avatar_url"
                  :backgroundColor="data.item.owner.avatar_color"
                  :initials="data.item.owner.initials"
                  :prettyName="data.item.owner.prettyName"
                  :small="true"
                />
              </template>
              <template v-slot:cell(name)="data">
                <router-link
                  v-if="$allowedRoute('templates.edit')"
                  :to="{
                    path: `/templates/${data.item.id}/edit`,
                  }"
                >
                  <b-button variant="link" style="color: var(--iq-primary)" class="p-0 text-left">
                    {{ data.item.name | notAvailable }}
                  </b-button>
                </router-link>
                <h6 v-else>{{ data.item.name | notAvailable }}</h6>
              </template>
              <template v-slot:cell(last_campaign_name)="data">
                {{ data.item.last_campaign_name | notAvailable }}
              </template>
              <template v-slot:cell(last_campaign_audience)="data">
                {{ data.item.last_campaign_audience | notAvailable }}
              </template>
              <template v-slot:cell(campaign_ctr)="data">
                {{ data.item.campaign_ctr | formatPercentage | notAvailable }} {{ data.item.campaign_ctr ? '%' : undefined }}
              </template>
              <template v-slot:cell(used_in_campaigns)="data">
                {{ data.item.used_in_campaigns | notAvailable }}
              </template>
              <template v-slot:cell(product_groups_pretty)="data">
                {{ data.item.product_groups_pretty | notAvailable }}
              </template>
              <template v-slot:cell(shared)="data">
                <b-badge
                  v-if="data.item.shared"
                  pill
                  variant="warning"
                  class="mr-1"
                  >Shared</b-badge
                >
                <b-badge v-else pill variant="default" class="mr-1"
                  >Not Shared</b-badge
                >
              </template>
               <template v-slot:cell(updated_at)="data">{{
                  data.value | formatDate | notAvailable
              }}</template>
              <template v-slot:cell(action)="data">
                <b-button
                  v-if="
                    (data.item.shared || data.item.owner_id === userId) &&
                    role !== 'sales_manager'
                  "
                  size="sm"
                  variant="warning"
                  class="mr-2"
                  @click="duplicateTemplate(data.item.id)"
                >
                  <i class="far fa-clone mr-0"></i>
                </b-button>
                <b-button
                  v-if="
                    (role === 'sales_manager' && data.item.shared === true) ||
                    (role === 'sales_person' && data.item.owner_id === userId)
                  "
                  variant="danger"
                  size="sm"
                  @click="toDeleteItem = data.item"
                >
                  <i class="ri-delete-bin-line m-0"></i>
                </b-button>
              </template>
            </b-table>
          </template>
        </iq-card>
      </b-col>
    </div>
    <div class="row d-flex justify-content-center">
      <b-pagination
        value="3"
        size="md"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
      ></b-pagination>
    </div>

    <b-modal
      id="delete-modal"
      :visible="!!toDeleteItem"
      title="Delete template "
      @hidden="toDeleteItem = null"
    >
      <p>
        If this template is assigned to campaign - it won't be possible to send
        this campaign and other template should be assigned instead.
      </p>
      <p>Do you really want to delete this template?</p>
      <template #modal-footer="{}">
        <b-button size="sm" variant="outline-dark" @click="toDeleteItem = null"
          >Cancel</b-button
        >
        <b-button
          size="sm"
          variant="danger"
          @click="deleteItem(toDeleteItem.id)"
          >Delete</b-button
        >
      </template>
    </b-modal>
  </b-container>
</template>
<style scoped>
.carditem {
  height: 450px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 0.5rem;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 3rem;
  position: relative;
  background: url("../../assets/images/newsletter-placeholder.png");
  /* background: url(https://assets.hongkiat.com/uploads/free-business-newsletter-templates/preview/2-hola.jpg); */
  background-size: cover;
}
.carditem__dimmer {
  opacity: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  transition: 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1rem;
}
.carditem__dimmer:hover {
  opacity: 1;
}
.carditem__tags {
  padding: 0.5rem;
  z-index: 100;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}
.carditem__title {
  opacity: 0.85;
  text-align: center;
  width: 100%;
  padding: 1rem;
  background: linear-gradient(
    to right,
    var(--iq-primary) 0%,
    var(--iq-primary-light) 100%
  );
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.carditem__title .h6 {
  color: white;
  margin-bottom: 0;
  opacity: 1;
}
.email {
  text-transform: none !important;
}
</style>
<script>
import { core } from "../../config/pluginInit";
import DeletedBadge from "./Components/DeletedBadge";
import gql from "graphql-tag";
import { getAccountSync } from "../../Utils/account";
import {getOwnerData} from "../../Utils/getOwnerData";
import Avatar from "./Components/Avatar.vue";

const LIST_TEMPLATES = gql`
  query templatesWithLastCampaign(
    $where: templates_with_last_campaign_bool_exp!
    $limit: Int!
    $offset: Int!
  ) {
    templates_with_last_campaign_aggregate(where: $where) {
      aggregate {
        totalCount: count
      }
    }
    templates_with_last_campaign(limit: $limit, offset: $offset, where: $where) {
      id
      name
      campaign_id
      campaign_name
      campaign_audience
      number_of_campaigns
      owner_id
      owner {
        id
        first_name
        last_name
        email
        avatar_url
        avatar_color
      }
      campaign_ctr
      template_product_groups {
        product_group {
          id
          name
        }
      }
      shared
      updated_at
    }
  }
`;
const DELETE_TEMPLATE = gql`
  mutation deleteTemplate($id: uuid!) {
    delete_templates_by_pk(id: $id) {
      id
    }
  }
`;
const LIST_AVAILABLE_USERS = gql`
  query getMySalesPersons($adminId: uuid!){
    users (
      where: {
        role: {
          _eq: sales_person
        }
        organizations: {
          organization: {
            admin_id: {
              _eq: $adminId
            }
          }
        }
      }
    ){
      id
      email
      first_name
      last_name
    }
  }
`;
const LIST_AVAILABLE_PRODUCT_GROUPS = gql`
  query {
    product_groups {
      id
      name
    }
  }
`;
const GET_TEMPLATE = gql`
  query getTemplateData($id: uuid!) {
    templates_by_pk(id: $id) {
      id
      name
      editor_data
      text
      html
    }
  }
`;
const CREATE_TEMPLATE = gql`
  mutation createTemplate($object: templates_insert_input!) {
    insert_templates_one(object: $object){
      id
      name
      editor_data
      text
      html
    }
  }
`;
export default {
  name: "Templates",
  data() {
    return {
      sortBy: "name",
      sortDesc: false,
      search: "",
      perPage: 200,
      currentPage: 1,
      rows: null,
      templates: [],
      error: false,
      loading: false,
      role: getAccountSync()?.defaultRole,
      userId: getAccountSync()?.userId,
      selectedUserIds: [],
      selectedProductGroupIds: [],
      selectedMinAudience: null,
      availableProductGroups: [],
      minAudienceOptions: [
        {value: '10', text: '>= 10'},
        {value: '20', text: '>= 20'},
        {value: '50', text: '>= 50'},
        {value: '100', text: '>= 100'},
      ],
      fields: [
        { key: "owner", label: "Owner", sortable: true },
        { key: "name", label: "Name", sortable: true },
        { key: "campaign_name", label: "Last campaign", sortable: true },
        { key: "campaign_audience", label: "Audience", sortable: true },
        { key: "number_of_campaigns", label: "Used in campaigns", sortable: true },
        { key: "campaign_ctr", label: "TX", sortable: true },
        { key: "product_groups_pretty", label: "Product groups", sortable: false },
        { key: "shared", label: "Shared", sortable: true },
        { key: "updated_at", label: "Last change", sortable: true },
        { key: "action", label: "Action", sortable: false },
      ],
      toDeleteItem: null
    };
  },
  components: {
    DeletedBadge,
    Avatar
  },
  apollo: {
    templates: {
      query: LIST_TEMPLATES,
      fetchPolicy: "no-cache",
      variables() {
        const vars = {
          where: {},
          limit: this.perPage,
          offset: this.currentPage * this.perPage - this.perPage
        };

        // filter
        const searchPart = this.search
          ? {
              _or: [
                {
                  name: {
                    _ilike: `%${this.search}%`
                  }
                }
              ]
            }
          : null;

        const whereAttributes = [];
        if (this.selectedUserIds.length > 0) {
          whereAttributes.push({
            owner_id: {
              _in: this.selectedUserIds
            }
          });
        }

        if (this.selectedMinAudience) {
          whereAttributes.push({
            campaign_audience: {
              _gte: parseInt(this.selectedMinAudience)
            }
          });
        }

        if (this.selectedProductGroupIds.length > 0) {
          whereAttributes.push({
            template_product_groups: {
              product_group: {
                id: {
                  _in: this.selectedProductGroupIds
                }
              }
            }
          })
        }

        const finalFilter = [];
        if (searchPart !== null) {
          finalFilter.push(searchPart);
        }
        if (whereAttributes.length > 0) {
          whereAttributes.forEach(att => finalFilter.push(att));
        }

        vars.where = {
          _and: finalFilter
        };

        return vars;
      },
      update: data => {
        return data.templates_with_last_campaign;
      },
      result({ data, loading, networkStatus }) {
        if (!loading) {
          this.rows = data.templates_with_last_campaign_aggregate.aggregate.totalCount;
        }
      }
    },
    users: {
      query: LIST_AVAILABLE_USERS,
      variables(){
        return {
          adminId: getAccountSync()?.userId,
        }
      }
    },
    product_groups: {
      query: LIST_AVAILABLE_PRODUCT_GROUPS,
      result({data, loading, networkStatus}){
        if (!loading) {
          this.productGroupOptions = data.product_groups.sort((a, b) => {
            // Convert property values to strings for case-insensitive sorting
            const propA = String(a['name']).toLowerCase();
            const propB = String(b['name']).toLowerCase();

            if (propA < propB) {
              return -1; // a should come before b
            } else if (propA > propB) {
              return 1; // b should come before a
            } else {
              return 0; // a and b are equal
            }
          })
        }
      }
    }
  },
  mounted() {
    core.index();
  },
  computed: {
    items() {
      const d = this.templates.map(template => {
        return {
          ...template,
          owner: getOwnerData(template.owner),
          product_groups_pretty: template?.template_product_groups.map(pg => ({
            id: pg?.id,
            name: pg?.product_group?.name
          })).map(i => i.name).join(", ")
        };
      });
      return d;
    },
    style() {
      return `background: #252549 url(${darkLoader}) no-repeat scroll center center;background-size: 150px;`;
    },
    toDeleteTemplate() {
      if (!this.toDeleteItem) {
        return null;
      }
      const t = this.templates.find(i => i.id === this.toDeleteItem);
      if (!t) {
        return null;
      }
      return t;
    }
  },
  methods: {
    async deleteItem(id) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_TEMPLATE,
          variables: {
            id
          }
        });
        this.$toast.success(`Template deleted`);
        this.toDeleteItem = null;
        this.$apollo.queries.templates.refetch();
      } catch (error) {
        this.$toast.error(`Failed to delete template : ${error.message}`);
      }
    },
    async duplicateTemplate(id) {
      try {
        const getTemplateResponse  = await this.$apollo.query({
          query: GET_TEMPLATE,
          variables: {
            id: id
          }
        })
        const tpl = getTemplateResponse?.data?.templates_by_pk;
        if (!tpl) {
          throw new Error(`template not found`)
        }
        const newTplObject = {
          name: `Copy of ${tpl?.name || 'template'}`,
          text: tpl.text,
          html: tpl.html,
          editor_data: tpl.editor_data,
        }
        const createTemplateResponse  = await this.$apollo.mutate({
          mutation: CREATE_TEMPLATE,
          variables: {
            object: newTplObject,
          }
        })
        const newTplId = createTemplateResponse.data.insert_templates_one.id;
        this.$router.push({path: `/templates/${newTplId}/edit`});
        this.$toast.success(`Template duplicated.`);
      } catch (error) {
        this.$toast.error(`Failed to create template : ${error.message}`);
      }
    }
  }
};
</script>
